(function () {
  if (window.__cardSwatchListenerAdded) return;
  window.__cardSwatchListenerAdded = true;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.product-card');
    if (!card) return;

    var img = card.querySelector('.product-card__image');
    var url = swatch.getAttribute('data-swatch-image');
    if (img && url) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    }

    var siblings = card.querySelectorAll('.product-card__swatch');
    siblings.forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  });
})();
